export const backdrops = [
  'B-001|Verdant Caverns',
  'B-002|Luminara Passage',
  'B-003|Xyphora Prime',
  'B-004|Eldoria Forest',
  'B-005|Tokyo 2050',
  'B-006|Horizon Retreat',
  'B-007|Celestial Haven',
  'B-008|Aeon Spire',
  'B-009|Cosmic Void',
  'B-010|Medieval Village',
  'B-011|Desert Sketch',
  'B-012|Game-like Desert',
  'B-013|New York Studio',
];
